import { useQuery } from "@tanstack/react-query"
import { supabase } from '../../api';

const query = async (userId: string) => {
  const { data, error } = await supabase
  .from('user_profiles')
  .select(`*`)
  .eq('id', userId)
  .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export const useGetMyUser = (userId: string) => {
  return useQuery(['useGetMyUser', userId], () => query(userId), {
    enabled: !!userId,
  })
}
